import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal, Space, Button, message } from 'antd';
import intl from 'react-intl-universal';

import { logoutToLogin } from '@/utils/user';
import * as HandoverApi from '@/api/handover';
import { logout } from '@/redux/actions/login';

import styles from './index.module.scss';

const ForceHandover = (props) => {
  const { userInfo, visible } = props;

  const [submitLoading, setSubmitLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const history = useHistory();

  const signOut = () => {
    props.logout().then(() => {
      logoutToLogin();
    });
  };

  const handover = async () => {
    try {
      setSubmitLoading(true);
      const res = await HandoverApi.submitHandover({});
      if (res && res.status) {
        message.success(intl.get('handover_duty_message_success'));
        setModalVisible(false);
      }
      setSubmitLoading(false);
    } catch (err) {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    setModalVisible(visible);
  }, [visible]);

  const modalFooter = () => {
    return (
      <Space>
        <Button onClick={() => signOut()}>{intl.get('handover_duty_logout_btn')}</Button>
        <Button type="primary" loading={submitLoading} onClick={() => handover()}>
          {intl.get('handover_duty_confirm_btn')}
        </Button>
      </Space>
    );
  };

  return (
    <Modal
      open={modalVisible}
      title={intl.get('handover_duty_modal_title')}
      footer={modalFooter()}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      destroyOnClose
    >
      <>
        <p>{intl.get('handover_duty_modal_content')}</p>
        <div className={styles['block-item']} style={{ marginTop: 16 }}>
          <label>{intl.get('handover_duty_current_user')}</label>
          <span>{userInfo?.name || '-'}</span>
        </div>
      </>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { userInfo } = state.user;
  return { userInfo };
};

export default connect(mapStateToProps, { logout })(ForceHandover);
